// extracted by mini-css-extract-plugin
export const sectionContentBlocks = "contentBlocks-module--sectionContentBlocks--3l1B2";
export const intro = "contentBlocks-module--intro--bYU75";
export const sectionContainer = "contentBlocks-module--sectionContainer--3nxFj";
export const blocksWrapper = "contentBlocks-module--blocksWrapper--3h57c";
export const blockItem = "contentBlocks-module--blockItem--16reY";